// Sticky Header Class Toggle Javascript Start

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".ann_with_header_main"); // Adjust selector as needed
  const stickyOffset = 50; // Pixels scrolled before sticking

  window.addEventListener("scroll", function () {
    if (window.scrollY > stickyOffset) {
      header.classList.add("sticky_header");
    } else {
      header.classList.remove("sticky_header");
    }
  });
});

// Sticky Header Class Toggle Javascript End

/****** Swiper slide show ******/
   
window.SlideshowObjs = window.SlideshowObjs || [];
    function initSlideshow(section) {
        section = (typeof section === typeof undefined || section == 'undefined') ? document : section;
        var swiperItems = section.querySelectorAll('.swiper');
        swiperItems.forEach(function(swiperItem, index) {
            if (swiperItem.classList.contains('product-media-gallery'))
                return false;
            var _this = swiperItem,
                sliderOptions = _this.getAttribute('data-slider-options'),
                isNumberNavigation = _this.getAttribute('data-swiper-number-navigation');
            var isNumberPaginationProgress = _this.getAttribute('data-swiper-number-pagination-progress') || false;
            if (typeof(sliderOptions) !== 'undefined' && sliderOptions !== null ) {
                sliderOptions =JSON.parse(sliderOptions);
                if (sliderOptions.hasOwnProperty('effect')) {
                    if (sliderOptions.effect == 'creative') {
                        sliderOptions['creativeEffect'] = {
                            prev: {
                                translate: [0, 0, -400],
                            },
                            next: {
                                translate: ["100%", 0, 0],
                            }
                        };
                    }
                    
                    if (sliderOptions.effect == 'fade') {
                        sliderOptions['fadeEffect'] = {
                            crossFade: true,
                        };
                    }
                }

                /* If user have provided "data-thumb-direction" attribute then below code will execute */
                if( sliderOptions['thumbs'] != '' && sliderOptions['thumbs'] != undefined ) {
                    var mdThumbDirection = _this.getAttribute( 'data-thumb-direction' );
                    sliderBreakPoint = _this.getAttribute( 'data-thumb-breakpoint' ) !== 'undefined' ? _this.getAttribute( 'data-thumb-breakpoint' ) : sliderBreakPoint;

                    var viewportWidth = window.innerWidth;    
                    if(viewportWidth > 767) {
                        sliderOptions['thumbs']['autoScrollOffset'] = 1;
                    }
                    
                    if( mdThumbDirection != '' && mdThumbDirection != undefined ) {
                        var thumbDirection   = ( sliderOptions['thumbs']['swiper']['direction'] != '' && sliderOptions['thumbs']['swiper']['direction'] != undefined ) ? sliderOptions['thumbs']['swiper']['direction'] : mdThumbDirection;
                        sliderOptions['thumbs']['swiper']['on'] = {
                            init: function() {
                                if( getWindowWidth() <= sliderBreakPoint ) {
                                    this.changeDirection( mdThumbDirection );
                                } else {
                                    this.changeDirection( thumbDirection );
                                }
                                this.update();
                            },
                            resize: function () {
                                if( getWindowWidth() <= sliderBreakPoint ) {
                                    this.changeDirection( mdThumbDirection );
                                } else {
                                    this.changeDirection( thumbDirection );
                                }
                                this.update();
                            }
                        };
                    }
                }
                sliderOptions['on'] = {
                    init: function () {
                        var length = this.loopedSlides ? this.slides.length - 2 : this.slides.length;
                        /* For Number Navigation - On Swiper Initialize - Add Navigation Number */
                        if (isNumberNavigation == '1') {
                            _this.find('.swiper-button-next').textContent( '02' );
                            _this.find('.swiper-button-prev').textContent( '0' + length );
                        }
                        /* End */
                        /* Number pagination progress */
                        if (isNumberPaginationProgress) {
                            _this.parentNode.find('.number-next').textContent('0' + length);
                            _this.parentNode.find('.number-prev').textContent('01');
                            _this.parentNode.find('.swiper-pagination-progress')[0].style.setProperty('--swiper-progress', (100 / length).toFixed(2) + '%');
                        }
                        /* End */
                    },
                    slideChange: function(swiper) {
                        var length = this.loopedSlides ? this.slides.length - 2 : this.slides.length,
                            active = (this.realIndex) + 1,
                            next = active + 1,
                            prev = active - 1; 
                        if ( active == 1 ) { 
                            prev = length; 
                        }
                        if ( active == length ) { 
                            next = 1;
                        }
                        /* For Number Navigation - On Swiper Slide Change - Change Navigation Number */
                        if (isNumberNavigation == '1') {
                            _this.find('.swiper-button-next').textContent( next < 10 ? '0' + next : next ); 
                            _this.find('.swiper-button-prev').textContent( prev < 10 ? '0' + prev : prev ); 
                        }
                        /* End */
                        /* Number pagination progress */
                        if (isNumberPaginationProgress) {
                            _this.parentNode.find('.number-prev').each(function () {
                                $(this).textContent(active < 10 ? '0' + active : active);
                            });
                            _this.parentNode.find('.swiper-pagination-progress')[0].style.setProperty('--swiper-progress', ((100 / length) * active).toFixed(2) + '%');
                        }
                        /* End */
                        if (swiper.$el.hasClass('product-image-main')) {
                            const currSlide = swiper.slides[swiper.activeIndex];
                            const mediaType = currSlide.dataset.mediaType || false;
                            const mediaHost = currSlide.dataset.mediaHost || false;

                            // Pause all videos
                            if (typeof window.currPlayingVid != typeof undefined && window.currPlayingVid != 'undefined' && window.currPlayingVid.plyrInstance.playing) {
                                window.currPlayingVid.plyrInstance.pause();
                            }

                            if (mediaType == 'model') {
                                swiper.allowTouchMove = false;
                            } else {
                                swiper.allowTouchMove = true;
                            }
                        }
                    }
                };
                swiperItem.sliderOptions = sliderOptions;
                var swiperObj = new Swiper(swiperItem, sliderOptions);
                window.SlideshowObjs.push(swiperItem);
            }
        });
    }

  let product_media_sklider = '';
function pdpslider() {

    let   product_slider = document.querySelector('[data-pdp-slider]');
       if(product_slider){
              sliderOptions = product_slider.getAttribute('data-slider-options'),
               slideroptionConfig = JSON.parse(sliderOptions);
           product_media_sklider = new Swiper("[data-main-pdp-swiper]", slideroptionConfig);
  }
}
function pdpslider_main() {

  // let   product_slider_rec = document.querySelector('recently-viewed');
  //           if(product_slider_rec){
  //            let   sliderOptions_rec = product_slider_rec.querySelector('[data-slider-options]').getAttribute('data-slider-options'),
  //                slideroptionConfig_rec = JSON.parse(sliderOptions_rec);
  //             recently_viewed_slider= new Swiper(".recently-viewed-slider", slideroptionConfig_rec);
  //           }
}

(function() {
initSlideshow();
  pdpslider();
  pdpslider_main();
})();

document.addEventListener('shopify:section:load', function (event){
 initSlideshow();
  pdpslider();
    pdpslider_main();
  });
/****** Swiper slide show End******/

// ======= PDP for copy coupon code
const couponContainers = document.querySelectorAll(".coupon_code");

if (couponContainers.length > 0) {
  couponContainers.forEach(couponContainer => {
    couponContainer.addEventListener("click", function (event) {
      event.preventDefault(); // stop default click behavior

      let copyText = couponContainer.querySelector("span").innerText;

      // Copy to clipboard
      let tempTextArea = document.createElement("textarea");
      tempTextArea.value = copyText;
      document.body.appendChild(tempTextArea);
      tempTextArea.select();
      document.execCommand("copy");
      document.body.removeChild(tempTextArea);

      console.log("Copied:", copyText);

      // Find existing tooltip inside same container
      let tooltip = couponContainer.nextElementSibling; // assumes tooltip div is right after <a>
      
      if (tooltip && tooltip.classList.contains("discount-copy-tooltip")) {
        tooltip.classList.add("active"); // show tooltip
        setTimeout(() => {
          tooltip.classList.remove("active"); // hide after 2s
        }, 2000);
      }
    });
  });
}



  // ======= PDP description for read more js 
// class ReadMoreMainText extends HTMLElement {
//   constructor() {
//     super();
//     const content = this.querySelector('[data-main-content]');
//     const btn = this.querySelector('[data-redmore-btn]');
//     const limit = 200;

//     if (!content || !btn) return;

//     const fullText = content.textContent.trim();
//     if (fullText.length <= limit) {
//       btn.style.display = 'none';
//       return;
//     }

//     const visible = fullText.substring(0, limit);
//     const hidden = fullText.substring(limit);
//     content.innerHTML = `${visible}<span class="more-text" style="display:none;">${hidden}</span>`;

//     btn.addEventListener('click', (e) => {
//       e.preventDefault();
//       const more = content.querySelector('.more-text');
//       const expanded = more.style.display === 'inline';
//       more.style.display = expanded ? 'none' : 'inline';
//       btn.querySelector('[data-btn-text-toggal]').textContent = expanded
//         ? btn.dataset.redMoreText
//         : btn.dataset.redLessText;
//     });
//   }
// }
// customElements.define('read-more-main-text', ReadMoreMainText);
document.addEventListener("DOMContentLoaded", function () {
  // Select all main containers
  const containers = document.querySelectorAll("[data-main-conteaner-wapper]");

  // Loop through each container independently
  containers.forEach(container => {
    const contentWrapper = container.querySelector("[data-main-content]");
    const readMoreBtn = container.querySelector("[data-redmore-btn]");

    if (!contentWrapper || !readMoreBtn) return;

    // Get all direct child elements (e.g. paragraphs, divs, etc.)
    const elements = Array.from(contentWrapper.children);

    // If there are 4 or fewer elements, hide the button
    if (elements.length <= 4) {
      readMoreBtn.style.display = "none";
      return;
    }

    // Hide everything after the first 4 elements
    for (let i = 4; i < elements.length; i++) {
      elements[i].style.display = "none";
    }

    // Add click event to show all elements and hide the button
    readMoreBtn.addEventListener("click", function (e) {
      e.preventDefault();
      elements.forEach(el => (el.style.display = ""));
      readMoreBtn.style.display = "none";
    });
  });
});





// ==============mega menu hover image show js===========

const childItems = document.querySelectorAll('.child-nav li');
const imageItems = document.querySelectorAll('.mega-menu-img .child-nav__item-collection-image');
const childNav = document.querySelector('.child-nav');
if (childItems.length > 0) {

  
childItems.forEach(item => {
  item.addEventListener('mouseenter', function () {
    const selectedTitle = this.getAttribute('data-collection-title');

    // Remove 'active' from all images
    imageItems.forEach(img => img.classList.remove('active'));

    // Add 'active' to the matching image
    imageItems.forEach(img => {
      if (img.getAttribute('data-collection-img') === selectedTitle) {
        img.classList.add('active');
      }
    });
  });
});

// On mouse leave of the entire .child-nav, remove all active classes
childNav.addEventListener('mouseleave', function () {
  imageItems.forEach(img => img.classList.remove('active'));
});
}



// -=========== collection list show JS
    const showMoreBtn = document.querySelector('.js-show-more');
    const hiddenItems = document.querySelectorAll('.extra-collection');
    let visibleCount = 7;
    const batchSize = parseInt(showMoreBtn?.dataset.batch || 7);

    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', function () {
        let count = 0;
        hiddenItems.forEach((item, index) => {
          if (index >= visibleCount && count < batchSize) {
            item.classList.remove('hidden');
            count++;
          }
        });

        visibleCount += batchSize;

        if (visibleCount >= hiddenItems.length + 7) {
          showMoreBtn.style.display = 'none';
        }
      });
    }
  




 const socialWrapper = document.querySelector('.main-menu__content .social');
  const localizationDiv = document.querySelector('.mob__localization');

  if (socialWrapper && localizationDiv) {
    localizationDiv.parentNode.insertBefore(socialWrapper, localizationDiv.nextSibling);
  }


// ---------------------------------



  const plusButton = document.getElementById("plus-button");
  const minusButton = document.getElementById("minus-button");
  const quantityInput = document.getElementById("quantity");
  const fieldsContainer = document.querySelector(".teilnehmer-filed-box");

  if (plusButton && minusButton && fieldsContainer) {
    function updateFields() {
      const qty = parseInt(quantityInput.value);
      const titleText = fieldsContainer.getAttribute("data-title") || "Teilnehmer";
      fieldsContainer.innerHTML = ''; // Clear previous fields

      for (let i = 1; i <= qty; i++) {
        const vornameId = `vorname ${i}`;
        const nachnameId = `nachname ${i}`;

        const fieldSet = document.createElement('div');
        fieldSet.classList.add('name-fields');

        fieldSet.innerHTML = `
          <span class="field-title">${titleText} ${i}</span>
         <div class="name-field-box">
          <input type="text" id="${vornameId}" name="contact[${vornameId}]" required placeholder="Vorname*">
          
          <input type="text" id="${nachnameId}" name="contact[${nachnameId}]" required placeholder="Nachname*">
          </div>
        `;

        fieldsContainer.appendChild(fieldSet);
      }
    }

    plusButton.addEventListener("click", function() {
      quantityInput.value = parseInt(quantityInput.value) + 1;
      updateFields();
    });

    minusButton.addEventListener("click", function() {
      if (parseInt(quantityInput.value) > 1) {
        quantityInput.value = parseInt(quantityInput.value) - 1;
        updateFields();
      }
    });

    // Initial fields load
    updateFields();
  }






// ================product-configurator js========
  const innerDropdown = document.querySelector(".ring_selector");
  const outerDropdown = document.querySelector(".outerring_selector");
  if (innerDropdown || outerDropdown){
    let innerRingSKU = "";
      let outerRingSKU = "";

      // ✅ Function to read the SKU from a dropdown value (safe split)
      function getSKU(value) {
        if (!value) return "";
        const parts = value.split("|");
        return parts[2] ? parts[2].trim() : "";
      }

      // ✅ Function to handle inner dropdown changes
      function handleInnerChange() {
        const selectedValue = innerDropdown.value;
        const [imageUrl, productUrl, sku] = selectedValue.split("|");

        const productConfiguratorItem = innerDropdown.closest(".product_configurator_item");

        if (productConfiguratorItem) {
          const configuratorLink = productConfiguratorItem.querySelector(".product_configurator_link");
          const configuratorImage = configuratorLink ? configuratorLink.querySelector("img") : null;
          const addLinks = productConfiguratorItem.querySelectorAll(".add_product_url");

          if (configuratorImage) configuratorImage.src = imageUrl;
          if (configuratorLink) configuratorLink.href = productUrl;
          addLinks.forEach(link => (link.href = productUrl));
        }

        innerRingSKU = sku;
        combiRingChanged();
      }

      // ✅ Function to handle outer dropdown changes
      function handleOuterChange() {
        const selectedValue = outerDropdown.value;
        const [imageUrl, productUrl, sku] = selectedValue.split("|");

        const productConfiguratorItem = outerDropdown.closest(".product_configurator_item");

        if (productConfiguratorItem) {
          const configuratorLink = productConfiguratorItem.querySelector(".product_configurator_link");
          const configuratorImage = configuratorLink ? configuratorLink.querySelector("img") : null;
          const addLinks = productConfiguratorItem.querySelectorAll(".add_product_url");

          if (configuratorImage) configuratorImage.src = imageUrl;
          if (configuratorLink) configuratorLink.href = productUrl;
          addLinks.forEach(link => (link.href = productUrl));
        }

        outerRingSKU = sku;
        combiRingChanged();
      }

      // ✅ Combined image builder
      function combiRingChanged() {
        const combiImg = document.querySelector(".sku-img-add img");

        // Get the current selected values in case one changed
        if (!innerRingSKU) innerRingSKU = getSKU(innerDropdown.value);
        if (!outerRingSKU) outerRingSKU = getSKU(outerDropdown.value);

        console.log("innerRingSKU:", innerRingSKU);
        console.log("outerRingSKU:", outerRingSKU);

        if (!innerRingSKU || !outerRingSKU) return;

        const inner = innerRingSKU.replaceAll(" ", "_");
        const outer = outerRingSKU.replaceAll(" ", "_");

        const imageUrl = `https://media.drachenfels-design.de/produktbilder/${outer}-${inner}.jpg`;

        console.log("Final Combined Image URL:", imageUrl);

        if (combiImg) {
          combiImg.src = imageUrl;
          combiImg.alt = imageUrl;
        }
      }

      // ✅ Attach event listeners
      if(innerDropdown){
        innerDropdown.addEventListener("change", handleInnerChange);
      }
      if(outerDropdown){
      outerDropdown.addEventListener("change", handleOuterChange);
      }

      // ✅ On page load — get SKUs from currently selected options and set combined image
      innerRingSKU = getSKU(innerDropdown.value);
      outerRingSKU = getSKU(outerDropdown.value);

      // Build initial combined image on load
      combiRingChanged();
    }
  


// =================== size popup open
const popupSize = document.querySelector('.size_image_with_text .section__block--button a');
const closeBtn = document.querySelector('.size_image_with_text .close_popup');
const bodyClass = document.querySelector('body');

// On Open (Add Class)
if (popupSize) {
  popupSize.addEventListener('click', function(event) {
    event.preventDefault();

    const targetElement = document.querySelector('.size_image_with_text .size_popup');
    if (targetElement) {
      targetElement.classList.add('size_popup_p');
      bodyClass.classList.add('size_popup_open');
    }
  });
}

// On Close (Remove Class)
if (closeBtn) {
  closeBtn.addEventListener('click', function() {
    const targetElement = document.querySelector('.size_image_with_text .size_popup');
    if (targetElement) {
      targetElement.classList.remove('size_popup_p');
      bodyClass.classList.remove('size_popup_open');
    }
  });
}

// ------------------- product card swatch

document.addEventListener('change', function (event) {
  const target = event.target;

  // Only handle custom swatch radio buttons
  if (target.matches('product-card .card__info .custom-swatch input[type="radio"]')) {
    const price = target.getAttribute('data-price-get');
      const price_camper = target.getAttribute('data-price-camper-get') || null;
    const image = target.getAttribute('data-image-get');
    const getid = target.getAttribute('data-id-get');
    console.log(price,"price")
    console.log(image,'image')
    const cardContainer = target.closest('product-card');
    if (!cardContainer) return;
    const linkElement = cardContainer.querySelector('.card-link');

    if (linkElement && getid) {
      const baseUrl = linkElement.href.split('?')[0]; 
      linkElement.href = `${baseUrl}?variant=${getid}`;
    }
    // Update price
    const priceElement = cardContainer.querySelector('.price__current');
    if (priceElement && price) {
      priceElement.innerHTML = price;
    }

     const priceElementCamper = cardContainer.querySelector('.price__was--supercents');
    if (priceElementCamper && price_camper) {
      priceElementCamper.innerHTML = price_camper;
      priceElementCamper.classList.remove('hidden');
    }else{
      priceElementCamper.classList.add('hidden');
    }

    // Update image
    const imageElement = cardContainer.querySelector('.card__media img');
    if (imageElement && image) {
      imageElement.srcset = image;
      imageElement.src = image; // In case src is used instead of srcset
    }
  }
});


// Toggle Mobile Filters
document.querySelectorAll('.js-toggle-filters').forEach(el => {
  el.addEventListener('click', () => {
    document.body.classList.add('filter_open');
  });
});

// Close button inside drawer
document.querySelectorAll('.facets .drawer__close-btn').forEach(el => {
  el.addEventListener('click', () => {
    document.body.classList.remove('filter_open');
  });
});

// Close when clicking outside drawer
document.addEventListener('click', function(event) {
  const facetsDrawer = document.querySelector('.facets.drawer');
  const toggleBtn = event.target.closest('.js-toggle-filters');

  // If drawer exists, click is outside drawer, and not on toggle button
  if (
    facetsDrawer &&
    !facetsDrawer.contains(event.target) &&
    !toggleBtn
  ) {
    document.body.classList.remove('filter_open');
  }
});

// ===========review button=======

const reviewBtns = document.querySelectorAll('.reviews_show');
const popup = document.querySelector('.size_popup_review');

// Show popup after widget loads
reviewBtns.forEach(btn => {
  btn.addEventListener('click', () => {
        document.body.classList.add('review_active'); // body par class add

    const checkInterval = setInterval(() => {
      const reviewWidget = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg');
      
      if (reviewWidget && reviewWidget.children.length > 0) {
        popup.classList.add('active'); // class add karo
        clearInterval(checkInterval);  // stop check
      }
    }, 500);
  });
});

// Close review popup
let closeBtnN = document.querySelector('.close_popup_review'); 
if (closeBtnN) {
  closeBtnN.addEventListener('click', () => {
    popup.classList.remove('active'); // popup hide
       document.body.classList.remove('review_active'); 
  });
}

if (!document.body.classList.contains('template_steine-perlen')){

  const tabtitlemeta = document.querySelectorAll(".colle_tab_title");
  
  if (tabtitlemeta.length > 0) {
    tabtitlemeta.forEach(titleEl => {
      titleEl.addEventListener("click", function (event) {
        event.preventDefault(); 
  
        const titleAttr = this.getAttribute("data-title");
  const closestfinddAll = document.querySelectorAll('.collection_tab_maintitle');
        closestfinddAll.forEach(tab => tab.classList.remove("tb_active"));
  
        const closestfindd = this.closest('.collection_tab_maintitle');
        console.log(closestfindd,"closestfindd")
        closestfindd.classList.add("tb_active");
  
  
        const allContents = document.querySelectorAll(".colle_tab_content-main");
        allContents.forEach(content => content.classList.remove("active"));
  
        const matchingContent = document.querySelector(`.colle_tab_content-main[data-content="${titleAttr}"]`);
        if (matchingContent) {
          matchingContent.classList.add("active");
        }
  
      });
    });
  }

}





const phoneNumber = document.querySelector('.desk-phone-number');
const phoneDropdown = document.querySelector('.phon_dropdown');

if (phoneNumber && phoneDropdown) {
    phoneNumber.addEventListener('click', () => {
        phoneDropdown.classList.toggle('active');
    });
}


